import { Box, styled } from "@mui/material";

export const MessageContent = styled(Box, { shouldForwardProp: prop => prop !== "color" })(({ theme, color }) => ({
  color: theme.palette[color]?.main,
  flexGrow: 1
}));

export const MessagesWrapper = styled(Box, { shouldForwardProp: prop => prop !== "active" })(({ theme, active }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingBlock: active ? theme.spacing(1) : 0
}));
